import { render, staticRenderFns } from "./voyage-subscription.vue?vue&type=template&id=34b4024e&scoped=true"
import script from "./voyage-subscription.vue?vue&type=script&lang=js"
export * from "./voyage-subscription.vue?vue&type=script&lang=js"
import style0 from "./voyage-subscription.vue?vue&type=style&index=0&id=34b4024e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4024e",
  null
  
)

export default component.exports